import {
	CustomerGuidelinesMeta,
	FAQsMeta,
	FlexiPassPolicyMeta,
	PrivacyPolicyMeta,
	RefundsAndCancellationMeta,
	SubscriptionPolicyMeta,
	TermsAndConditionsMeta,
	RouteMeta,
	AdsCampaignMeta,
	SITE,
} from './config';

const MDX_METADATA = {
	CustomerGuidelinesMeta,
	FAQsMeta,
	FlexiPassPolicyMeta,
	PrivacyPolicyMeta,
	RefundsAndCancellationMeta,
	SubscriptionPolicyMeta,
	TermsAndConditionsMeta,
};

/** */
export const getFormattedDate = (date: Date): string =>
	date
		? new Date(date).toLocaleDateString('en-us', {
				year: 'numeric',
				month: 'short',
				day: 'numeric',
		})
		: '';

export function attachEvent(selector: string, event: string, fn: Function) {
	const matches = document.querySelectorAll(selector);
	if (matches && matches.length) {
		matches.forEach((elem) => {
			elem.addEventListener(event, () => fn(elem), false);
		});
	}
}

export const isLegalPage = (url: URL) => {
	return [
		CustomerGuidelinesMeta.canonical.pathname,
		FAQsMeta.canonical.pathname,
		FlexiPassPolicyMeta.canonical.pathname,
		RefundsAndCancellationMeta.canonical.pathname,
		PrivacyPolicyMeta.canonical.pathname,
		SubscriptionPolicyMeta.canonical.pathname,
		TermsAndConditionsMeta.canonical.pathname,
	].some((pagePathname: string) => url.pathname === pagePathname);
};

export const isRouteExplorationPage = (url: URL) => {
	return url.pathname.includes('routes/');
};

export const isRoutePage = (url: URL) => {
	return url.pathname.includes('route/');
};

export const mdxMetadataGenerator = (pageName: keyof typeof MDX_METADATA): PageMeta => {
	return MDX_METADATA[pageName];
};

export const getParam = (param: string) => {
	const url = new URL(window.location.href);
	const params = new URLSearchParams(url.search);
	return params.get(param);
};

export const humanizeURL = (url: string): string => {
	const specialCharacters = /[()\-]+/g;
	const spaces = /[\s\:]+/g; // \s matches any white space character
	// Use the replace method to replace matched characters with a hyphen '-'
	const replacedString = url.toLowerCase().replace(specialCharacters, '').trimEnd().replace(spaces, '-');
	return replacedString;
};

export const metaRoutePage = (route: RouteInfoByShift): PageMeta => {
	const meta = {
		...RouteMeta,
		canonical: new URL(`/route/${humanizeURL(`${route.pickup.name} ${route.dropoff.name}/`)}`, SITE.origin),
		title: `Cityflo Route | ${route.pickup.name} to ${route.dropoff.name}`,
		description: `Find your stops on our ${route.pickup.name} to ${route.dropoff.name} route`,
	}

	return meta;
};

// TODO:
export const metaAdsCampaignPage = (brand: BrandData): PageMeta => {
	const meta = {
		...AdsCampaignMeta,
		canonical: new URL(`/route/${brand.brand}/`, SITE.origin),
		title: `Cityflo Ads Campaign | ${brand.brand} | ${brand.sectionHeader}`,
		description: '',
	}

	return meta;
};

export const isDoubleShiftRoute = (route: RouteExplorationCard): boolean => {
	if (route?.morning?.id && route?.evening?.id) {
		return true;
	}
	return false;
}

export default {};